import { useState } from 'react';

export const useDialog = openDefault => {
  const [open, setOpen] = useState(openDefault ? openDefault : false);
  const onClose = () => setOpen(false);
  const onOpen = () => setOpen(true);

  return {
    open,
    onClose,
    onOpen
  };
};
